import React, { useEffect } from "react";
import "../assets/css/cxda.css";
import "aos/dist/aos.css";
import AOS from "aos";
import "bootstrap/dist/css/bootstrap.min.css";
import dubaiSMELogo from "../assets/sms-6.png";
import cocaColaLogo from "../assets/sms-2.png";
import dmccLogo from "../assets/sms-3.png";
import edbLogo from "../assets/sms-7.png";
import rakbankLogo from "../assets/sms-5.png";

import jumiaLogo from "../assets/j-1.png";
import afreximbankLogo from "../assets/j-2.png";
import cxdaLogo from "../assets/j-3.png";
export default function SMEAssetsSection() {
    useEffect(() => {
            AOS.init({ duration: 1000 });
          }, []);
  return (
    <div className="sme-assets-section container my-2" data-aos="fade-up">
      <h4 className="text-center mb-4 contact-title">
        CXDA – An excellent traction and market penetration to date

      </h4>

      {/* ASSETS SECTION */}
      <div className="rounded-box mb-4">
        <div className="row align-items-center">
          <div className="col-md-2 text-center">
            <h5 className="fw-bold">ASSETS</h5>
           
          </div>
          <div className="col-md-2">
             <p>Financial products based on local SMEs</p>
          </div>
          <div className="col-md-2">
            <p>
              <strong>Information, transparency, and standardization</strong>
            </p>
          </div>
          <div className="col-md-6">
           
            <p className="mb-0">
              <strong>Foundational Phase - Information</strong> <br/> Loan Origination,
              Servicing, Business Data (Company / Credit / Counterparty), Credit
              ratings, market data (transactions & inventory count).
            </p>
          </div>
        </div>
      </div>

      {/* DUBAI SECTION */}
      <div className="rounded-box mb-4">
        <div className="row align-items-center">
          <div className="col-md-2 text-center">
            <h5 className="fw-bold">DUBAI (UAE)</h5>
          </div>
          <div className="col-md-10 text-center d-flex flex-wrap justify-content-center gap-5">
            <img src={dubaiSMELogo} alt="Dubai SME" className="partner-logo" />
            <img src={cocaColaLogo} alt="Coca Cola" className="partner-logo" />
            <img src={dmccLogo} alt="DMCC" className="partner-logo" />
            <img src={edbLogo} alt="EDB" className="partner-logo" />
            <img src={rakbankLogo} alt="Rakbank" className="partner-logo" />
          </div>
        </div>
      </div>

      {/* REGIONAL SECTION */}
      <div className="rounded-box">
        <div className="row align-items-center">
          <div className="col-md-2 text-center">
            <h5 className="fw-bold g-5">REGIONAL<br />Middle East & <br/> Africa</h5>
          </div>
          <div className="col-md-10 text-center d-flex flex-wrap justify-content-center gap-5">
            <div>
              <img src={jumiaLogo} alt="Jumia" className="partner-logo-1" />
              {/* <p className="text-muted small mt-1">KENYA</p> */}
            </div>
            <div>
              <img src={afreximbankLogo} alt="Afreximbank" className="partner-logo-1" />
              {/* <p className="text-muted small mt-1">EGYPT</p> */}
            </div>
            <div>
              <img src={cxdaLogo} alt="CXDA" className="partner-logo-1" />
              {/* <p className="text-muted small mt-1">EGYPT</p> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
